import {AgentContext} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';
import {CampaignTreeType} from '../../campaigns.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import toConnectedMapNode from '../../store/campaignLogic/utils/toConnectedMapNode';
import {toConceptNode} from '../copilotCampaigns.dataConverters';
import {ConceptNode} from '../copilotCampaigns.types';
import {DTNode} from 'common/src/modules/decisionTree/decisionTree.types';

type ConceptPlanContext = {
  conceptPlan: ConceptNode[];
};

function conceptPlanContext(store: CLStore): AgentContext<ConceptPlanContext> {
  function getter(): ConceptPlanContext {
    const conceptNodes = store.getState().campaignPage.campaignLogic.nodes[CampaignTreeType.Concept];

    if (!conceptNodes || Object.keys(conceptNodes).length === 0) {
      return {conceptPlan: []};
    }

    const nodeArray: DTNode[] = Object.values(conceptNodes).map(toConnectedMapNode);
    const nodesWithoutCampaignNode = nodeArray.filter((node) => node.type !== NodeType.CAMPAIGN);
    const conceptPlan: ConceptNode[] = nodesWithoutCampaignNode.map(toConceptNode);

    return {conceptPlan};
  }

  function formatter({currentContext}: {currentContext: ConceptPlanContext}): string {
    const {conceptPlan} = currentContext;

    if (!conceptPlan || conceptPlan.length === 0) {
      return 'The current concept plan is empty.';
    }

    return `The current concept plan is:\n${JSON.stringify(conceptPlan)}`;
  }

  return {
    title: 'Current concept plan',
    getter,
    formatter,
  };
}

export default conceptPlanContext;
